<ng-container [ngSwitch]="mode">
  <div *ngSwitchCase="'ionic'" class="ionic-mode">
    <ion-accordion-group
      #accordionGroup
      *ngIf="{ value: false } as expand"
      [multiple]="multiple"
      [value]="defaultSection"
      (ionChange)="expand.value = !expand.value">
      <ng-container *ngFor="let element of deviceInfo$ | async">
        <ion-accordion
          *ngFor="let category of element | keyvalue"
          class="w-full bg-white bg-opacity-60 fx-align-center"
          [value]="category.key">
          <ion-item lines="none" slot="header">
            <span class="body-3 text-grey-400 text-400 text-uppercase">
              {{ category.key | translate | titlecase }}
            </span>
          </ion-item>
          <ion-grid
            *ngIf="accordionGroup.value === category.key || multiple"
            slot="content"
            class="body-3 text-grey-400 {{ containerStyle }} p-0"
            fixed>
            <ion-row class="ion-justify-content-around">
              <ng-container *ngFor="let attribute of category.value | keyvalue">
                <ion-col
                  *ngIf="attribute.value.type === 'data'; else noDataType"
                  class="body-2 text-500 {{ attribute.value.bgColorClass || '' }} radius-4 mt-1"
                  [class.d-none]="attribute.value.hide || (attribute.value.hide$ | async)"
                  [size]="attribute.value.size || '5'">
                  <div class="fx-col fx-center p-3 border-box s-full">
                    {{ attribute.value.name | translate }}
                    <ng-container *ngIf="{ value: attribute.value.value$ | async } as attribute">
                      <span *ngIf="attribute.value !== null; else loading"
                        class="body-3 mt-1 text-300"
                        [innerHTML]="attribute.value">
                      </span>
                    </ng-container>
                  </div>
                </ion-col>

                <ng-template #noDataType>
                  <ng-container *ngIf="attribute.value.type === 'component' && (attribute.value.value$ | async) as c; else loading">
                    <ng-container *ngTemplateOutlet="c.component; context: c.context"></ng-container>
                  </ng-container>
                </ng-template>
              </ng-container>
            </ion-row>
          </ion-grid>
        </ion-accordion>
      </ng-container>
    </ion-accordion-group>

    <ng-template #loading>
      <ion-skeleton-text class="w-11p mx-auto h-9 radius-4 my-3" animated></ion-skeleton-text>
    </ng-template>
  </div>

  <div *ngSwitchCase="'material'">
    <div class="fx-col fx-gap-3">
      <ng-container *ngIf="(deviceInfo$ | async) as deviceInfo; else loading">
        <ng-container *ngFor="let element of deviceInfo">
          <ng-container *ngFor="let category of element | keyvalue">
            <div class="p-3 radius-4 block-bg-contrast">
              <lib-block-title
                id="power-title"
                class="mb-3"
                [title]="category.key | translate">
              </lib-block-title>
              <div [ngClass]="containerStyle">
                <ng-container *ngFor="let attribute of category.value | keyvalue">
                  <div *ngIf="attribute.value.type === 'data'; else noDataTypeMat"
                      [class.d-none]="attribute.value.hide || (attribute.value.hide$ | async)"
                      class="data-attribute">
                    {{ attribute.value.name | translate }}
                    <span *ngIf="(attribute.value.value$ | async) !== null; else loadingMat"
                          [innerHTML]="attribute.value.value$ | async">
                    </span>
                  </div>
                  <ng-template #noDataTypeMat>
                    <ng-container *ngIf="attribute.value.type === 'component' && (attribute.value.value$ | async) as c; else loadingMat">
                      <ng-container *ngTemplateOutlet="c.component; context: c.context"></ng-container>
                    </ng-container>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <ng-template #loadingMat>
      <div class="material-skeleton">
        <div class="fx-row fx-gap-3 pb-3 fx-wrap">
          <ion-skeleton-text
            *ngFor="let _ of [].constructor(5); let odd = odd"
            class="fx-b-0 h-23 radius-4 min-w-50"
            animated
            [ngClass]="{
              'fx-g-1': odd,
              'fx-g-2': !odd
            }">
          </ion-skeleton-text>
        </div>
      </div>
    </ng-template>
    <ng-template #loading>
      <div
        *ngFor="let _ of [].constructor(5)"
        class="p-3 radius-4">
        <lib-block-title
          class="mb-3 w-20 block-title-skeleton"
          title="...">
        </lib-block-title>
        <div class="fx-row fx-gap-3 pb-3 fx-wrap">
          <ion-skeleton-text
            *ngFor="let _ of [].constructor(5); let odd = odd"
            class="fx-b-0 h-23 radius-4 min-w-50"
            animated
            [ngClass]="{
              'fx-g-1': odd,
              'fx-g-2': !odd
            }">
          </ion-skeleton-text>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
